import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GallectionsListView';
import { AppState } from '../../../../../types/store';
import {
  setCurrentlyViewedFolderId,
  addFolderToFullViewList,
} from '../../../../actions/gallectionSection';
import { getOrderedNonEmptyFolders } from '../../../../selectors/folders';
import {
  getFullViewFolderIds,
  hasMoreDeviationsInLastFullViewFolder,
  isFetchingPausedInLastFullViewFolder,
  getCurrentlyViewedFolderId,
} from '../../../../selectors/gallectionSection';

export type StateProps = Pick<
  Props,
  | 'folders'
  | 'fullViewFolderIds'
  | 'currentlyViewedFolderId'
  | 'hasMoreDeviationsInLastFullViewFolder'
  | 'isFetchingPausedInLastFullViewFolder'
>;
export type DispatchProps = Pick<
  Props,
  'setCurrentlyViewedFolderId' | 'addFolderToFullViewList'
>;
export type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  folders: getOrderedNonEmptyFolders(state),
  fullViewFolderIds: getFullViewFolderIds(state),
  currentlyViewedFolderId: getCurrentlyViewedFolderId(state),
  hasMoreDeviationsInLastFullViewFolder: hasMoreDeviationsInLastFullViewFolder(
    state
  ),
  isFetchingPausedInLastFullViewFolder: isFetchingPausedInLastFullViewFolder(
    state
  ),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setCurrentlyViewedFolderId,
  addFolderToFullViewList,
};

export default connect(mapStateToProps, mapDispatchToProps);
